import React from 'react';
import { Link } from 'react-router-dom';

const menuItems = ['Platform', 'Solutions', 'Customers', 'About Us'];

const Navbar: React.FC = () => {
  return (
    <header className="relative left-1/2 w-screen -translate-x-1/2 border-b border-line bg-card">
      <div className="mx-auto flex h-[70px] w-full max-w-[1728px] items-center justify-between px-8 lg:px-20">
        <div className="flex items-center gap-12">
          <div className="text-[24px] font-extrabold leading-none tracking-[-0.08em] text-primary-800">FlintPay</div>
        </div>
        <nav className="hidden flex-1 items-center justify-center gap-10 text-[14px] font-medium tracking-[-0.01em] text-muted lg:flex">
          {menuItems.map((item) => (
            <span key={item} className="transition hover:text-primary-800 font-bold">
              {item}
            </span>
          ))}
        </nav>
        {/* <div className="flex items-center gap-4">
          <Link
            to="/signup"
            className="inline-flex h-[42px] min-w-[122px] items-center justify-center rounded-full bg-primary-800 px-4 text-[14px] font-medium text-white transition-all duration-200 hover:bg-primary-700 focus:outline-none focus-visible:ring-4 focus-visible:ring-primary-300"
          >
            Get Started
          </Link>
          <Link
            to="/login"
            className="flex items-center gap-2 pl-2 text-[14px] font-bold tracking-[-0.01em] text-primary-800 transition hover:text-primary-600"
          >
            <span>Log In</span>
          </Link>
        </div> */}
      </div>
    </header>
  );
};

export default Navbar;
